import { useContext } from 'react';

import { AuthTokensRefreshDataContext } from '../../AuthTokensRefreshDataContext';

export const useAuthTokensRefreshData = () =>
  useContext(AuthTokensRefreshDataContext);
